const openNotifications = new Map();

export function browserNotificationsSupported() {
    return typeof window !== 'undefined' && typeof window.Notification === 'function';
}

export function browserNotificationPermission() {
    return browserNotificationsSupported() ? window.Notification.permission : 'unsupported';
}

export async function requestBrowserNotificationPermission() {
    if (!browserNotificationsSupported()) return 'unsupported';
    if (window.Notification.permission !== 'default') return window.Notification.permission;

    try {
        return await window.Notification.requestPermission();
    } catch {
        return window.Notification.permission;
    }
}

export function readBrowserNotificationPreference(storageKey, permission = browserNotificationPermission()) {
    if (permission !== 'granted') return false;

    try {
        return window.localStorage.getItem(storageKey) !== 'false';
    } catch {
        return true;
    }
}

export function storeBrowserNotificationPreference(storageKey, enabled) {
    try {
        window.localStorage.setItem(storageKey, enabled ? 'true' : 'false');
    } catch {
        // The current page can still honor its in-memory choice when storage is unavailable.
    }
}

export function isPageInactive() {
    if (typeof document === 'undefined') return true;

    return document.visibilityState !== 'visible' || !document.hasFocus();
}

export function showBrowserMessageNotification({messageId, title, body, onClick}) {
    if (!browserNotificationsSupported() || window.Notification.permission !== 'granted') return null;

    closeBrowserMessageNotification(messageId);
    try {
        const notification = new window.Notification(title, {
            body,
            tag: `customer-chat-message-${messageId}`,
        });
        openNotifications.set(messageId, notification);
        notification.onclick = () => {
            window.focus();
            onClick?.();
            notification.close();
        };
        notification.onclose = () => {
            if (openNotifications.get(messageId) === notification) {
                openNotifications.delete(messageId);
            }
        };

        return notification;
    } catch {
        return null;
    }
}

export function closeBrowserMessageNotification(messageId) {
    const notification = openNotifications.get(messageId);
    notification?.close();
    openNotifications.delete(messageId);
}

export function closeAllBrowserMessageNotifications() {
    openNotifications.forEach(notification => notification.close());
    openNotifications.clear();
}
